<template>
  <Wrapper :project="project">
    <div class="mx-auto mt-8 max-w-5xl px-4 sm:px-6 lg:px-8">
      <ul>
        <li v-for="(activity,key) in activities.data">
          <div class="relative pb-8">
            <span
              v-if="key < activities.data.length-1"
              class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-font-light"
              aria-hidden="true" />
            <div class="relative flex items-start space-x-3">
              <div class="relative">
                <img
                  class="flex h-10 w-10 items-center justify-center rounded-full bg-font-light object-cover ring-8 ring-white"
                  :src="activity.creator.profile_photo_url"
                  :alt="activity.creator.name">

                <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                  <ActivityIcon
                    :type="activity.type"
                    class="text-font-darkest" />
                </span>
              </div>
              <div class="min-w-0 flex-1">
                <div>
                  <div class="text-sm">
                    <a
                      href="#"
                      class="font-medium text-font-darkest">{{ activity.creator.name }}</a><span
                      v-if="activity.contact !== null"
                      class="text-xs text-font"> with <a
                      href="#"
                      class="font-medium text-font-darkest">{{ activity.contact.name }}</a></span>
                  </div>
                  <p class="mt-0.5 text-sm text-font">
                    <date-time-formatter :date-time="activity.created_at" />
                  </p>
                </div>
                <div class="mt-2 text-sm text-font-dark">
                  <p>
                    {{ activity.comment }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="activities.data.length === 0"
      class="flex flex-1 items-center justify-between truncate rounded-md bg-white">
      <div class="mb-8 flex-1 truncate px-4 py-2 text-center text-sm">
        <p
          class="font-medium text-font-light">
          No activities in this project yet
        </p>
      </div>
    </div>
    <pagination
      v-else
      :model="activities" />
  </Wrapper>
</template>

<script>
import ActivityIcon from '@/Components/ActivityIcon.vue';
import DateTimeFormatter from '@/Components/DateTimeFormatter.vue';
import Wrapper from './Wrapper.vue';
import Pagination from '../../ComponentsDeprecated/Pagination.vue';

export default {
  name: 'ActivityTab',
  components: {
    DateTimeFormatter,
    ActivityIcon,
    Wrapper,
    Pagination,
  },

  props: {
    project: Object,
    activities: Object,
  },

  data() {
    return {};
  },

  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped>

</style>
